import { asyncRouteAction, Routes } from "../lib/routing";
import CompanySpinnerContainer from "./components/CompanySpinnerContainer";
// Import only types

const routes: Routes = [
  {
    path: "",
    action: asyncRouteAction({
      loader: () => import(/* webpackChunkName: "companies_ShowContainer" */ "./components/ShowContainer"),
      Placeholder: CompanySpinnerContainer,
      async fetchInitialData(getState, dispatch, component) {
        await (component as any).fetchInitialData(getState, dispatch);
      },
      isInitialized(getState) {
        const { companies } = getState();
        return companies.show.isLoaded;
      },
    }),
  },
  {
    path: "/about",
    action: asyncRouteAction({
      loader: () => import(/* webpackChunkName: "companies_AboutPageContainer" */ "./components/AboutPageContainer"),
      Placeholder: CompanySpinnerContainer,
      async fetchInitialData(getState, dispatch, component) {
        await (component as any).fetchInitialData(getState, dispatch);
      },
      isInitialized(getState) {
        const { companies } = getState();
        return companies.about.isLoaded;
      },
    }),
  },
  {
    path: "/members",
    action: asyncRouteAction({
      loader: () => import(/* webpackChunkName: "companies_MemberPageContainer" */ "./components/MembersPageContainer"),
      Placeholder: CompanySpinnerContainer,
      async fetchInitialData(getState, dispatch, component) {
        await (component as any).fetchInitialData(getState, dispatch);
      },
      isInitialized(getState) {
        const { companies } = getState();
        return companies.members.isLoaded;
      },
    }),
  },
  {
    path: "/feed",
    action: asyncRouteAction({
      loader: () => import(/* webpackChunkName: "companies_PostsPageContainer" */ "./components/PostsPageContainer"),
      Placeholder: CompanySpinnerContainer,
      async fetchInitialData(getState, dispatch, component) {
        await (component as any).fetchInitialData(getState, dispatch);
      },
      isInitialized(getState) {
        const { companies } = getState();
        return companies.posts.isLoaded;
      },
    }),
  },
  {
    path: "/projects",
    action: asyncRouteAction({
      loader: () =>
        import(/* webpackChunkName: "companies_ProjectsPageContainer" */ "./components/ProjectsPageContainer"),
      Placeholder: CompanySpinnerContainer,
      async fetchInitialData(getState, dispatch, component) {
        await (component as any).fetchInitialData(getState, dispatch);
      },
      isInitialized(getState) {
        const { companies } = getState();
        return companies.projects.isLoaded;
      },
    }),
  },
];

export default routes;



// WEBPACK FOOTER //
// ./frontend/src/companies/routes.tsx